import Vue from 'vue';
import { Helper } from '@viddsee/server-api-client';

export default Vue.extend({
  functional: true,
  props: {
    // eslint-disable-next-line vue/require-prop-types
    data: {
      default: undefined,
    },
  },
  render(h, context) {
    const convertedProps = Helper.convertToCamelCase(context.props.data);

    const defaultScopedSlot = context.scopedSlots.default;
    return defaultScopedSlot(convertedProps) as any;
  },
});
